import axiosInstance from '../services/AxiosInstance';

export function getPropertyBankVerifyLists(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`bank-verify?pageNum=${pageNum}&pageSize=${pageSize}&${filterQuery}`);
}

export function getAllPropertyVerifyLists(filterQuery = "") {
    return axiosInstance.get(`bank-verify?populate=propertyId,agentId,bankId,userId&noPagination=true&${filterQuery}`);
}

export function updatePropertyBankVerify(id, data) {
    return axiosInstance.put(`bank-verify/${id}`,data);
}

export function getPropertyBankVerifyMessages( filterQuery = "") {
    return axiosInstance.get(`bank-verify-msg?${filterQuery}`);
}

export function createPropertyBankVerifyMessage( data ) {
    return axiosInstance.post(`bank-verify-msg`, data);
}
